import React, {useEffect} from 'react';


function NotFoundPage() {

    useEffect(() => {
        window.location.href = process.env.wordpressApiEndPoint;
    },[])

    return (
        <div className='hw-notfound-container'>
            <img alt="dahrtours-logo" src={`${process.env.wordpressApiEndPoint}wp-content/uploads/2023/10/dahrtours-404.png`} />
            <div className='hw-notfound-content'>
                <h1 className='text-center'>Oops, Wrong Destination!</h1>
                <p className=' text-center'>This page seems to have gone on its own adventure. Let’s get you back on track so you can continue exploring the world.</p>
            </div>
        </div>
  );
}

export default NotFoundPage;
